import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BpBadgeComponent } from "./bp-badge.component";

@NgModule({
	declarations: [BpBadgeComponent],
	exports: [BpBadgeComponent],
	imports: [CommonModule]
})
export class BpBadgeModule {}
